import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";


@Component({
  selector: 'app-modal-file-show-view',
  templateUrl: './modal-file-show-view.component.html',
  styleUrls: ['./modal-file-show-view.component.scss'],
})
export class ModalFileShowViewComponent {

  constructor(
    private readonly dialogRef: MatDialogRef<ModalFileShowViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }
  
  close() {
    this.dialogRef.close();
  }

}